const logs = JSON.parse(localStorage.getItem('consoleLogs')) || []
const erros = JSON.parse(localStorage.getItem('consoleErrors')) || []

const originalLog = console.log
console.log = function (...args) {
    try {
        const logEntry = {type: 'log', message: args.join(' '), time: new Date().toISOString()}
        logs.push(logEntry)
        const lastLogs = logs.slice(-10)
        localStorage.setItem('consoleLogs', JSON.stringify(lastLogs))
        originalLog.apply(console, args)
    } catch (e) {

    }
}

const originalError = console.error
console.error = function (...args) {
    try {
        const error = args.join(' ')
        if (error.includes('Using kebab-case for css properties in objects is not supported')) return
        const errorEntry = {type: 'error', message: args.join(' '), time: new Date().toISOString()}
        erros.push(errorEntry)
        const lastErrors = erros.slice(-10)
        localStorage.setItem('consoleErrors', JSON.stringify(lastErrors))
        originalError.apply(console, args)
    } catch (e) {

    }
}

export function getLogs() {
    return JSON.parse(localStorage.getItem('consoleLogs')) || []
}

export function getErros() {
    return JSON.parse(localStorage.getItem('consoleErrors')) || []
}
